import React, { useEffect } from 'react';
import './style/sideBar/styles.scss';
import './style/main.scss';
import BrowserRoute from './Routes/BrowserRoute';
import { useSelector } from 'react-redux';
import MainLoader from './components/MainLoader';
import {
  serverError,
  serverMaintenance
} from './Redux/Actions/authActions/authActions';
import ModalServerError from './Modals/ModalServerError/ModalServerError';
import Store from './Redux/Store';
import { ServiceWorkerUpdate } from './ServiceWorkerUpdate';
import { descriptionSuite, title, description } from './Utils/getInformations';
import ModalInformations from './Modals/ModalInformations/ModalInformations';

function App() {
  const pipeline = useSelector((state) => state.loader.pipeline);
  const isMaintenance = useSelector((state) => state.loader.isMaintenance);
  const isServerError = useSelector((state) => state.loader.isServerError);
  const contractFamily = useSelector((state) => state.auth?.user?.contractTypes);
  const [showModal, setShowModal] = React.useState(contractFamily?.includes('SANTE'));
  const [showDescription, setShowDescription] = React.useState(false);

  useEffect(() => {
    if (contractFamily?.includes('SANTE')) {
      setShowModal(true);
    }
  }, [contractFamily]);
  
  return (
    <>
    <ServiceWorkerUpdate /> 
    <div style={{ height: '100%' }}>
      <BrowserRoute />
      <ModalServerError
        show={isMaintenance === true || isServerError === true}
        onHide={
          isMaintenance
            ? () => Store.dispatch(serverMaintenance())
            : () => Store.dispatch(serverError())
        }
        isMaintenance={isMaintenance}
      />
      <ModalInformations
        show={showModal}
        onHide={() => setShowModal(false)}
        title={title}
        message={description}
        description={descriptionSuite}
        showDescription={showDescription}
        setShowDescription={() => setShowDescription(!showDescription)}
      />
      {pipeline.length > 0 && (
        <div
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 9999,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            backgroundColor: '#ffffff80'
          }}
        >
          <MainLoader />
        </div>
      )}
    </div>
    </>
  );
}

export default App;
